// extracted by mini-css-extract-plugin
export default {"wrapper":"OrganizationEditPage_wrapper__fNm5B"};